import { useEffect, useState } from "react";
import izenuAPI from "../../../services/izenuAPI";

/**
 * Ativo / Inativo for one ad. An inactive ad stays in the panel but the public
 * fetch endpoints stop returning it, so the apps no longer show it.
 */
export default function AdActiveToggle({ type, id, active, onChanged }) {
    const [on, setOn] = useState(active !== 0);
    const [saving, setSaving] = useState(false);

    useEffect(() => setOn(active !== 0), [active]);

    const toggle = async (e) => {
        e.stopPropagation();
        const next = !on;
        setOn(next);
        setSaving(true);
        try {
            const { data: r } = await izenuAPI.post("/admin/ads/update.php", { type, id, active: next ? 1 : 0 });
            if (!r.response) throw new Error("not saved");
            if (onChanged) onChanged(next);
        } catch (err) {
            console.log(err);
            setOn(!next);
            alert("Não foi possível mudar a visibilidade. Tenta mais tarde.");
        }
        setSaving(false);
    };

    return (
        <button
            type="button"
            onClick={toggle}
            disabled={saving}
            title={on ? "Visível nas apps — clica para esconder" : "Escondido das apps — clica para mostrar"}
            style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12, opacity: saving ? 0.6 : 1 }}
        >
            <span
                style={{
                    position: "relative",
                    width: 30,
                    height: 16,
                    borderRadius: 999,
                    background: on ? "#22c55e" : "#9ca3af",
                    transition: "background .15s",
                    flexShrink: 0,
                }}
            >
                <span
                    style={{
                        position: "absolute",
                        top: 2,
                        left: on ? 16 : 2,
                        width: 12,
                        height: 12,
                        borderRadius: 999,
                        background: "#fff",
                        transition: "left .15s",
                    }}
                />
            </span>
            <span style={{ color: on ? "#16a34a" : "#6b7280", fontWeight: 500 }}>{on ? "Ativo" : "Inativo"}</span>
        </button>
    );
}
